import { put, call, takeEvery, all } from 'redux-saga/effects';

import * as types from './types';
import * as actions from './actions';
import * as api from './api';

import { error } from 'notifications/actions';

export function* autopay({ payload: { userId, enabled } }) {
  try {
    const resp = yield call(api.autopay, userId, enabled);
    yield put(actions.autopayChange(resp.data.enabled));
  }
  catch (err) {
    yield put(actions.autopayChangeFailed());
    if (err.response && err.response.data && (err.response.data.detail || err.response.data.message)) {
      yield put(error('autopay', err.response.data.detail || err.response.data.message));
    } else {
      yield put(error('autopay', 'Could not change autopay settings at this time. Contact customer service by clicking the button in the lower right corner'));
    }  
  }
}

export function* watchAutopay() {
  yield takeEvery(types.AUTOPAY, autopay);
}

export function* watchAccount() {
  yield all([
    call(watchAutopay),
  ]);
}
